import { render, staticRenderFns } from "./SAnimal.vue?vue&type=template&id=4b98eb72"
import script from "./SAnimal.vue?vue&type=script&lang=js"
export * from "./SAnimal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports